import { render, staticRenderFns } from "./PlanupMultiMessagesChat.vue?vue&type=template&id=9ab33e1e"
import script from "./PlanupMultiMessagesChat.vue?vue&type=script&lang=js"
export * from "./PlanupMultiMessagesChat.vue?vue&type=script&lang=js"
import style0 from "./PlanupMultiMessagesChat.vue?vue&type=style&index=0&id=9ab33e1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports